import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";

import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";

@Component({
  selector: 'app-latest-image-widget',
  templateUrl: './latest-image-widget.component.html',
  styleUrls: ['./latest-image-widget.component.css']
})
export class LatestImageWidgetComponent extends MultiSourceMultiValueWidget implements OnInit {
  //@ViewChild('sourceImage') sourceImage;
  ranges: any[] = [];
  point: SharedPoint;
  activeImage: string;

  override ngOnInit(){
  }

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  widgetBeforeInit(): void {
  }

  widgetAfterInit(): void {
  }

  override widgetDataLoadComplete(): void {
      
  }

  seriesCache: SharedSeries;

  widgetLiveDataLoaded(s: any) {
    if (s != null && s.uri != null){
      if (this.seriesCache == null){
        this.seriesCache = {uri:s.uri,values:[]} as SharedSeries;
      }
      // pop the first item, push the new one
      if (this.seriesCache) {
        this.seriesCache.values.pop();
        const value = Math.round(s.point.value*1000)/1000;
        this.seriesCache.values.push({uri:s.uri, value:value, timeStamp: s.point.timeStamp} as SharedPoint)
      }
      this.widgetDataLoaded(this.seriesCache);
    }
  }

  widgetDataLoadTimeout(){
    
  }
  
  widgetDataLoaded(series: SharedSeries): void {
    this.seriesCache = series;
    this.point = series.values[series.values.length-1];
    // what one to display?
    for (let img of (this.widget as any).images){
      if (img.min <= this.point.value && img.max > this.point.value){
        this.activeImage = img;
      }
    }
  }

}
